export const PRODUCTION = 'production'
export const DEVELOPMENT = 'development'
export const STAGING = 'staging'
export const RELEASE_STAGE = import.meta.env.VITE_RELEASE_STAGE || import.meta.env.NODE_ENV || PRODUCTION
export const IS_DEVELOPMENT = RELEASE_STAGE === DEVELOPMENT
export const IS_PRODUCTION = RELEASE_STAGE === PRODUCTION
export const CUSTOM_API_URL = import.meta.env.VITE_API_URL || ''

export const GTM_DEBUG_MODE = !IS_PRODUCTION
export const GTM_ID = IS_PRODUCTION ? import.meta.env.VITE_GTM_ID : import.meta.env.VITE_DEV_GTM_ID

export const GA4_MEASUREMENT_ID = IS_PRODUCTION ? import.meta.env.VITE_GA4_MEASUREMENT_ID : import.meta.env.VITE_DEV_GA4_MEASUREMENT_ID
export const GA4_DEBUG_MODE = IS_PRODUCTION ? false : true

export const STORYBLOK_KEY = !IS_DEVELOPMENT ? import.meta.env.VITE_PUBLIC_STORYBLOK_KEY : import.meta.env.VITE_PREVIEW_STORYBLOK_KEY
export const STORYBLOK_VERSION = !IS_DEVELOPMENT ? 'published' : 'draft'

export const COMPANY_NAME = 'Maverix Broadband'
export const COMPANY_NAME_UPPERCASE_FIRST = 'MAVERIX Broadband'
export const COMPANY_PHONE = '+1-720-740-0888'
export const CONTACT_PHONE_NUMBER = '7207400888'

export const SOCIAL_FACEBOOK_URL = 'https://www.facebook.com/maverixBB/'
export const SOCIAL_GOOGLE_URL = 'https://www.google.com/maps/place/Maverix+Broadband/@39.4997395,-104.710539,11z/data=!4m6!3m5!1s0x6efa953aab4d9d79:0xf16f6e005df2538!8m2!3d39.4997395!4d-104.710539!16s%2Fg%2F11sxyfbj_4?sa=X&ved=2ahUKEwiHhJfJkIT-AhVCOH0KHfGbBMYQ_BJ6BQiqARAI&coh=164777&entry=tt&shorturl=1'
export const SOCIAL_NEXTDOOR_URL = 'https://nextdoor.com/pages/maverix-broadband-parker-co/'

export const HELP_CENTER_BASE_URL_EN = 'https://help.maverixbroadband.com/en/'
export const HELP_CENTER_BASE_URL_ES = 'https://help.maverixbroadband.com/es/' // NOTE: (7-7-25) Not used in the app yet, but included for future localization

export const BASE_URL = import.meta.env.VITE_BASE_URL || 'https://maverixbroadband.com'

const accountUrls = {
	[PRODUCTION]: 'https://account.maverixbroadband.com',
	[STAGING]: 'https://staging-mx-account.maverixbroadband.com',
	[DEVELOPMENT]: 'https://dev-mx-account.maverixbroadband.com'
}

const portalUrls = {
	[PRODUCTION]: 'https://portal.maverixbroadband.com/',
	[STAGING]: 'https://staging-mx-portal.maverixbroadband.com/',
	[DEVELOPMENT]: 'https://dev-mx-portal.maverixbroadband.com/'
}

export const ACCOUNT_URL = accountUrls[RELEASE_STAGE] || accountUrls[PRODUCTION]
export const PORTAL_URL = portalUrls[RELEASE_STAGE] || portalUrls[PRODUCTION]

const apiUrls = {
	[PRODUCTION]: 'https://api.maverixbroadband.com',
	[STAGING]: 'https://staging-mx-back.maverixbroadband.com',
	[DEVELOPMENT]: 'https://dev-mx-back.maverixbroadband.com'
}

export const API_BASE = CUSTOM_API_URL || apiUrls[RELEASE_STAGE]
export const API_ENDPOINT_NON_BUSINESS_CONTACT = '/contact/nonBusiness'
export const API_ENDPOINT_BUSINESS_CONTACT = '/contact/business'
export const API_ENDPOINT_ALERTS = '/alerts'
export const API_ENDPOINT_SIGNUP = '/prospect/signup'
export const API_ENDPOINT_PROSPECT_LEAD = '/prospect/lead'
export const API_ENDPOINT_ADDRESS = '/prospect/address'
export const API_ENDPOINT_ADDRESS_COORDINATES = '/prospect/address/coordinates'
export const API_ENDPOINT_ADDRESS_PLACE_ID = '/prospect/address/placeId'
export const API_ENDPOINT_EVENTS = '/portal/kiosk/events'
export const API_ENDPOINT_AUTH_LOGIN = '/auth/login'

export const LEGACY_CONTACT_API_ENDPOINT = '/contact.php?json=true'
export const LEGACY_FIBER_API_ENDPOINT = '/fiber.php?json=true'
export const LEGACY_LOGIN_ENDPOINT = '/login.php?json=true'
export const LEGAL_NAME = 'Maverix Broadband, Inc.'

export const SHARED_COOKIE_DOMAIN = '.maverixbroadband.com'

const intercomAppIds = {
	[PRODUCTION]: import.meta.env.INTERCOM_PRODUCTION_APP_ID,
	[STAGING]: import.meta.env.INTERCOM_SANDBOX_APP_ID,
	[DEVELOPMENT]: import.meta.env.INTERCOM_SANDBOX_APP_ID
}

export const INTERCOM_APP_ID = intercomAppIds[RELEASE_STAGE]

export default {
	PRODUCTION,
	DEVELOPMENT,
	RELEASE_STAGE,
	IS_PRODUCTION,
	GA4_MEASUREMENT_ID,
	GA4_DEBUG_MODE,
	GTM_ID,
	GTM_DEBUG_MODE,
	LEGACY_CONTACT_API_ENDPOINT,
	COMPANY_NAME,
	COMPANY_NAME_UPPERCASE_FIRST,
	COMPANY_PHONE,
	HELP_CENTER_BASE_URL_EN,
	HELP_CENTER_BASE_URL_ES,
	BASE_URL,
	LEGACY_LOGIN_ENDPOINT,
	API_BASE,
	API_ENDPOINT_NON_BUSINESS_CONTACT,
	API_ENDPOINT_BUSINESS_CONTACT,
	API_ENDPOINT_ALERTS,
	API_ENDPOINT_SIGNUP,
	API_ENDPOINT_ADDRESS,
	API_ENDPOINT_EVENTS,
	API_ENDPOINT_AUTH_LOGIN,
	STORYBLOK_KEY,
	STORYBLOK_VERSION,
	SOCIAL_FACEBOOK_URL,
	SOCIAL_GOOGLE_URL,
	SOCIAL_NEXTDOOR_URL,
	ACCOUNT_URL,
	LEGAL_NAME,
	INTERCOM_APP_ID,
	CONTACT_PHONE_NUMBER
}
